export default function generateTableColumnDescription(column, index) {
    // Guards against a developer forgetting to put some columns
    // in the `columns` list when not using a `schema`.
    // For example, a developer may pass `data` with `7` columns
    // but only specify `6` of them in the `columns` list.
    // Hence, it handles missing column description here.
    if (!column) {
        return '';
    }

    // To ensure the column number starts as in Excel.
    const columnNumber = index + 1;

    const columnName = column.column || `Column ${columnNumber}`;

    // `tableColumn` format is described here:
    // https://learn.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.tablecolumn
    return `<tableColumn id="${columnNumber}" name="${columnName}"/>`;
}
